import { render, staticRenderFns } from "./homepage-trending-mixes.vue?vue&type=template&id=a56c18a2&"
import script from "./homepage-trending-mixes.vue?vue&type=script&lang=js&"
export * from "./homepage-trending-mixes.vue?vue&type=script&lang=js&"
import style0 from "./homepage-trending-mixes.vue?vue&type=style&index=0&id=a56c18a2&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports